import D1 from "../../components/ExcerciseTypes/Design/TypeIn";
import DesignUnderLine from "../../components/ExcerciseTypes/Design/DesignUnderLine";
import UI from "../../components/ExcerciseTypes/Design/UserInterface";

const json = {
  1: { // Exercise num
    unit: 'Unit 3',
    id: 'SB3-U3-P23-E1',
    audio: 'img/FriendsPlus/Page23/Audio/audio-e1-p23.mp3',
    video: '',
    component: UI,
    recorder: true,
    question: [],
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page23/E1/1.jpg' },
        { url: 'img/FriendsPlus/Page23/E1/2.jpg', audioUrl: 'img/FriendsPlus/Page23/Audio/tieude-e1-p23.mp3' },
        { url: 'img/FriendsPlus/Page23/E1/3.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page23/E1/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page23/E1/5.jpg' },
        { url: 'img/FriendsPlus/Page23/E1/6.jpg', audioUrl: 'img/FriendsPlus/Page23/Audio/br.mp3' },
        { url: 'img/FriendsPlus/Page23/E1/7.jpg' },
        { url: 'img/FriendsPlus/Page23/E1/8.jpg', audioUrl: 'img/FriendsPlus/Page23/Audio/fr.mp3' },
        { url: 'img/FriendsPlus/Page23/E1/9.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page23/E1/10.jpg' },
        { url: 'img/FriendsPlus/Page23/E1/11.jpg', audioUrl: 'img/FriendsPlus/Page23/Audio/gr.mp3' },
        { url: 'img/FriendsPlus/Page23/E1/12.jpg' },
        { url: 'img/FriendsPlus/Page23/E1/13.jpg', audioUrl: 'img/FriendsPlus/Page23/Audio/br.mp3' },
        { url: 'img/FriendsPlus/Page23/E1/14.jpg' },
        { url: 'img/FriendsPlus/Page23/E1/15.jpg', audioUrl: 'img/FriendsPlus/Page23/Audio/fr.mp3' },
        { url: 'img/FriendsPlus/Page23/E1/16.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page23/E1/17.jpg' },
        { url: 'img/FriendsPlus/Page23/E1/18.jpg', audioUrl: 'img/FriendsPlus/Page23/Audio/grass.mp3' },
        { url: 'img/FriendsPlus/Page23/E1/19.jpg' },
        { url: 'img/FriendsPlus/Page23/E1/20.jpg', audioUrl: 'img/FriendsPlus/Page23/Audio/grapes.mp3' },
        { url: 'img/FriendsPlus/Page23/E1/21.jpg' },
        { url: 'img/FriendsPlus/Page23/E1/22.jpg', audioUrl: 'img/FriendsPlus/Page23/Audio/brush.mp3' },
        { url: 'img/FriendsPlus/Page23/E1/23.jpg' },
        { url: 'img/FriendsPlus/Page23/E1/24.jpg', audioUrl: 'img/FriendsPlus/Page23/Audio/bread.mp3' },
        { url: 'img/FriendsPlus/Page23/E1/25.jpg' },
        { url: 'img/FriendsPlus/Page23/E1/26.jpg', audioUrl: 'img/FriendsPlus/Page23/Audio/frog.mp3' },
        { url: 'img/FriendsPlus/Page23/E1/27.jpg' },
        { url: 'img/FriendsPlus/Page23/E1/28.jpg', audioUrl: 'img/FriendsPlus/Page23/Audio/frisbee.mp3' },
        { url: 'img/FriendsPlus/Page23/E1/29.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page23/E1/30.jpg' },
      ],
    ],
  },
  2: { // Exercise num
    unit: 'Unit 3',
    id: 'SB3-U3-P23-E2',
    audio: 'img/FriendsPlus/Page23/Audio/audio-e2-p23.mp3',
    video: '',
    component: UI,
    recorder: true,
    question: [],
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page23/E2/1.jpg' },
        { url: 'img/FriendsPlus/Page23/E2/2.jpg', audioUrl: 'img/FriendsPlus/Page23/Audio/tieude-e2-p23.mp3' },
        { url: 'img/FriendsPlus/Page23/E2/3.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page23/E2/4.jpg' },
      ],
    ],
  },
  3: { // Exercise num
    unit: 'Unit 3',
    id: 'SB3-U3-P23-E3',
    audio: '',
    video: '',
    component: DesignUnderLine,
    exerciseKey: 'img/FriendsPlus/Page23/E3/Key/answerKey.png',
    totalInput: 8,
    titleImage: "",
    questionImage: [ // Row
      [
        // Column13
        { url: 'img/FriendsPlus/Page23/E3/75.jpg' },
      ],
      [
        // Column1
        { url: 'img/FriendsPlus/Page23/E3/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page23/E3/2.jpg' },
        { url: 'img/FriendsPlus/Page23/E3/3.jpg', input: 1 },
        { url: 'img/FriendsPlus/Page23/E3/4.jpg' },
        { url: 'img/FriendsPlus/Page23/E3/5.jpg', input: 2 },
        { url: 'img/FriendsPlus/Page23/E3/6.jpg' },
        { url: 'img/FriendsPlus/Page23/E3/7.jpg', input: 3 },
        { url: 'img/FriendsPlus/Page23/E3/8.jpg' },
        { url: 'img/FriendsPlus/Page23/E3/9.jpg', input: 4, isCorrect: true },
        { url: 'img/FriendsPlus/Page23/E3/10.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page23/E3/11.jpg' },
        { url: 'img/FriendsPlus/Page23/E3/12.jpg', input: 5 },
        { url: 'img/FriendsPlus/Page23/E3/13.jpg' },
        { url: 'img/FriendsPlus/Page23/E3/14.jpg', input: 6 },
        { url: 'img/FriendsPlus/Page23/E3/15.jpg' },
        { url: 'img/FriendsPlus/Page23/E3/16.jpg', input: 7 },
        { url: 'img/FriendsPlus/Page23/E3/17.jpg', input: 8 },
        { url: 'img/FriendsPlus/Page23/E3/18.jpg', input: 9 },
        { url: 'img/FriendsPlus/Page23/E3/19.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page23/E3/20.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page23/E3/21.jpg' },
        { url: 'img/FriendsPlus/Page23/E3/22.jpg', input: 10, isCorrect: true },
        { url: 'img/FriendsPlus/Page23/E3/23.jpg' },
        { url: 'img/FriendsPlus/Page23/E3/24.jpg', input: 11 },
        { url: 'img/FriendsPlus/Page23/E3/25.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page23/E3/26.jpg' },
        { url: 'img/FriendsPlus/Page23/E3/27.jpg', input: 12 },
        { url: 'img/FriendsPlus/Page23/E3/28.jpg', input: 13 },
        { url: 'img/FriendsPlus/Page23/E3/29.jpg' },
        { url: 'img/FriendsPlus/Page23/E3/30.jpg', input: 14, isCorrect: true },
        { url: 'img/FriendsPlus/Page23/E3/31.jpg' },
        { url: 'img/FriendsPlus/Page23/E3/32.jpg', input: 15, isCorrect: true },
        { url: 'img/FriendsPlus/Page23/E3/33.jpg' },
        { url: 'img/FriendsPlus/Page23/E3/34.jpg', input: 16, isCorrect: true },
        { url: 'img/FriendsPlus/Page23/E3/35.jpg' },
      ],
      [
        // Column7
        { url: 'img/FriendsPlus/Page23/E3/36.jpg' },
      ],
      [
        // Column8
        { url: 'img/FriendsPlus/Page23/E3/37.jpg' },
        { url: 'img/FriendsPlus/Page23/E3/38.jpg', input: 17 },
        { url: 'img/FriendsPlus/Page23/E3/39.jpg' },
        { url: 'img/FriendsPlus/Page23/E3/40.jpg', input: 18 },
        { url: 'img/FriendsPlus/Page23/E3/41.jpg' },
        { url: 'img/FriendsPlus/Page23/E3/42.jpg', input: 19 },
        { url: 'img/FriendsPlus/Page23/E3/43.jpg', input: 20, isCorrect: true },
        { url: 'img/FriendsPlus/Page23/E3/44.jpg' },
      ],
      [
        // Column9
        { url: 'img/FriendsPlus/Page23/E3/45.jpg' },
        { url: 'img/FriendsPlus/Page23/E3/46.jpg', input: 21 },
        { url: 'img/FriendsPlus/Page23/E3/47.jpg' },
        { url: 'img/FriendsPlus/Page23/E3/48.jpg', input: 22 },
        { url: 'img/FriendsPlus/Page23/E3/49.jpg' },
        { url: 'img/FriendsPlus/Page23/E3/50.jpg', input: 23 },
        { url: 'img/FriendsPlus/Page23/E3/51.jpg', input: 24 },
        { url: 'img/FriendsPlus/Page23/E3/52.jpg' },
      ],
      [
        // Column10
        { url: 'img/FriendsPlus/Page23/E3/53.jpg' },
      ],
      [
        // Column11
        { url: 'img/FriendsPlus/Page23/E3/54.jpg' },
        { url: 'img/FriendsPlus/Page23/E3/55.jpg', input: 25 },
        { url: 'img/FriendsPlus/Page23/E3/56.jpg' },
        { url: 'img/FriendsPlus/Page23/E3/57.jpg', input: 26, isCorrect: true },
        { url: 'img/FriendsPlus/Page23/E3/58.jpg' },
        { url: 'img/FriendsPlus/Page23/E3/59.jpg', input: 27 },
        { url: 'img/FriendsPlus/Page23/E3/60.jpg' },
        { url: 'img/FriendsPlus/Page23/E3/61.jpg', input: 28 },
        { url: 'img/FriendsPlus/Page23/E3/62.jpg' },
      ],
      [
        // Column12
        { url: 'img/FriendsPlus/Page23/E3/63.jpg' },
        { url: 'img/FriendsPlus/Page23/E3/64.jpg', input: 29 },
        { url: 'img/FriendsPlus/Page23/E3/65.jpg' },
        { url: 'img/FriendsPlus/Page23/E3/66.jpg', input: 30 },
        { url: 'img/FriendsPlus/Page23/E3/67.jpg' },
        { url: 'img/FriendsPlus/Page23/E3/68.jpg', input: 31 },
        { url: 'img/FriendsPlus/Page23/E3/69.jpg' },
        { url: 'img/FriendsPlus/Page23/E3/70.jpg', input: 32, isCorrect: true },
        { url: 'img/FriendsPlus/Page23/E3/71.jpg' },
        { url: 'img/FriendsPlus/Page23/E3/72.jpg', input: 33 },
        { url: 'img/FriendsPlus/Page23/E3/73.jpg' },
      ],
      [
        // Column13
        { url: 'img/FriendsPlus/Page23/E3/74.jpg' },
      ],
    ],
  },
  4: { // Exercise num
    unit: 'Unit 3',
    id: 'SB3-U3-P23-E4',
    audio: 'img/FriendsPlus/Page23/Audio/audio-e4-p23.mp3',
    video: '',
    component: D1,
    exerciseKey: 'img/FriendsPlus/Page23/E4/Key/answerKey.png',
    isAllowSubmit: false,
    question: [],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page23/E4/1.jpg'},
        { url: 'img/FriendsPlus/Page23/E4/2.jpg', audioUrl: 'img/FriendsPlus/Page23/Audio/tieude-e4-p23.mp3'},
        { url: 'img/FriendsPlus/Page23/E4/3.jpg'},
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page23/E4/4.jpg'},
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page23/E4/5.jpg'},
        { url: 'img/FriendsPlus/Page23/E4/6.jpg', input: true, answer: "br"},
        { url: 'img/FriendsPlus/Page23/E4/7.jpg'},
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page23/E4/8.jpg'},
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page23/E4/9.jpg'},
        { url: 'img/FriendsPlus/Page23/E4/10.jpg', input: true, answer: "gr"},
        { url: 'img/FriendsPlus/Page23/E4/11.jpg'},
        { url: 'img/FriendsPlus/Page23/E4/12.jpg', input: true, answer: "fr"},
        { url: 'img/FriendsPlus/Page23/E4/13.jpg'},
        { url: 'img/FriendsPlus/Page23/E4/14.jpg', input: true, answer: "br"},
        { url: 'img/FriendsPlus/Page23/E4/15.jpg'},
      ],      
    ]
  },
  5: { // Exercise num
    unit: 'Unit 3',
    id: 'SB3-U3-P23-E5',
    audio: '',
    video: '',
    component: UI,
    recorder: true,
    question: [],
    questionImage: [[{ url: 'img/FriendsPlus/Page23/E5/1.jpg' }]],
  },
}

export default json;